import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Modal, Select } from "risa-oasis-ui_v2";
import { ScreenNamesForBigQuery } from "../../../enums/eventsData";
import { EventsName } from "../../../enums/eventsName";
import { RootState } from "../../../redux/store/store";
import WarningIcon from "../../../svg/warningIcon";
import { generateFullName } from "../../../utils/generateOrderDataForTable";
import { getOrgIdForFetchExternalWorklist } from "../../../utils/organizationHelper";

import { apiWorkerManager } from "../../../workerManagers/workerManager";
interface BulkReassignModalProps {
  onClose: () => void;
  onSave: (selectedProvider: string) => void;
  isLoading: boolean;
  shouldLogEvent?: boolean;
}

const BulkReassignModal = (props: BulkReassignModalProps) => {
  const { data: providersDetails } = useSelector(
    (state: RootState) => state.allProviders,
  );
  const [selectedProvider, setSelectedProvider] = useState<string>("");
  const { user } = useSelector(
    (state: RootState) => state.firebaseAuthentication,
  );
  const orgId = getOrgIdForFetchExternalWorklist();
  const options = useMemo(() => {
    return providersDetails?.map((provider) => {
      return {
        value: provider?.DocID || "",
        label: generateFullName(
          provider.FirstName || "",
          "",
          provider?.LastName || "",
        ),
      };
    });
  }, [providersDetails]);

  return (
    <Modal
      dialogId={`bulk-reassign-modal`}
      title={"Reassign PA Orders"}
      saveButtonText={props.isLoading ? "Updating..." : "Save"}
      onSave={() => props.onSave(selectedProvider)}
      cancelText={"Close"}
      onClose={props.onClose}
      onCancel={props.onClose}
      disableSave={props.isLoading}
    >
      <div className="bulk-assign-order__container flex flex-col gap-2">
        <div className="bulk-assign-order__warning flex items-start justify-center gap-2 rounded-md bg-secondaryYellow-11 p-4">
          <WarningIcon height="20" width="20" />

          <div className="bulk-assign-order__warning-text text-small">
            This action will reassign the selected PA orders to the selected
            provider.
          </div>
        </div>
        <div className="bulk-assign-order__providers flex flex-col gap-2">
          <div className="bulk-assign-order__provider-text text-small font-semibold text-primaryGray-1">
            Select a provider to reassign the PA orders to:
          </div>
          <Select
            id="provider"
            onOptionChange={(option) => {
              if (props.shouldLogEvent) {
                apiWorkerManager.enqueueAndProcess({
                  event_name: EventsName.BULK_ASSIGN_BUTTON_CLICKED,
                  patient_id: "",
                  order_id: "",
                  user_id: user?.id ?? "",
                  user_email: user?.email ?? "",
                  org_id: orgId ?? "",
                  additional_data: {
                    screen_name: ScreenNamesForBigQuery.WORKLIST,
                    user_id: user?.id ?? "",
                    assigned_to: option.value,
                  },
                });
              }
              setSelectedProvider(option.value);
            }}
            label=""
            placeholder="Select a provider"
            options={options ?? []}
          />
        </div>
      </div>
    </Modal>
  );
};

export default BulkReassignModal;
